import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent } from "investira.react.components";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import withResponseHandling from "../../hoc/withResponseHandling";
import TipoEditForm from "./TipoEditForm";
import Carteira from "./Carteira";

const DialogTipoEdit = memo((props) => {
  const { state, actions } = useCarteirasContext();
  const params = useParams();

  const isOpen = state.isDialogOpen && state.dialogType === "tipo";

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogContent sx={{ pt: 4 }}>
        <TipoEditForm id={params.id} />
      </DialogContent>
    </Dialog>
  );
});

export default withResponseHandling(DialogTipoEdit);
